module.exports = __webpack_public_path__ + "static/media/view stock usage.a5f8e7a6.svg";